import type { Maybe } from '@adornis/base/utilTypes.js';
import { confirmDialog, guardDialog } from '@adornis/dialog/dialog-functions.js';
import { format } from 'date-fns';
import { UserEmailsAPI } from '../UserEmailsAPI.js';

const EXPLANATION_TEXTS = {
  alreadySent: (date: Date, isHimself: boolean) =>
    isHimself
      ? `Es wurde bereits eine Verifizierungsmail am ${format(date, 'dd.MM.yyyy')} an Ihre E-Mail-Adresse verschickt. Wollen Sie eine Neue versenden?`
      : `Es wurde bereits eine Verifizierungsmail am ${format(date, 'dd.MM.yyyy')} an die Person verschickt. Wollen Sie eine Neue versenden?`,
  notSent: (isHimself: boolean) =>
    isHimself
      ? `Wollen Sie eine Verifizierungsmail an Ihre E-Mail-Adresse verschicken? Wenn Sie die E-Mail-Adresse verändern wollen, klicken Sie auf den Stift.`
      : `Wollen Sie eine Verifizierungsmail an die Person verschicken? Wenn Sie die E-Mail-Adresse verändern wollen, klicken Sie auf den Stift.`,
};

export async function startEmailVerificationProcess(
  user: { _id: string },
  person: { _id: string; emailConfirmed: Maybe<boolean>; email: Maybe<string>; lastConfirmationEmailSent: Maybe<Date> },
): Promise<void> {
  let text: string;

  /**
   * The verification process can be started by the user himself or by and administrative user.
   */
  const userIsSendingHimself = user._id === person._id;
  const lasEmailSent = person.lastConfirmationEmailSent;

  /**
   *
   */
  if (lasEmailSent) {
    text = EXPLANATION_TEXTS.alreadySent(lasEmailSent, userIsSendingHimself);
  } else {
    text = EXPLANATION_TEXTS.notSent(userIsSendingHimself);
  }

  if (await confirmDialog(text)) {
    await guardDialog(() => UserEmailsAPI.sendVerificationEmail(person._id)(), {
      successText: 'Die Verifizierungsmail wurde verschickt.',
    });
  }
}
